module.exports = __webpack_public_path__ + "img/8d34918638e271884d6e4ae843192500.png";